import { useQuery } from "react-query"
import { get_listing_detail } from "../../services/jobs";


const useJobListingDetail = (id) => {
    return useQuery(['get_listing_detail', id], () => get_listing_detail(id))
}

export default useJobListingDetail;